import React from 'react';

const Icon = ({ className, type, ...props }) => <i className={`${className} fa fa-${type}`} {...props} />;

export default Icon;
